import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import _ from 'lodash';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class GroupService {

  constructor(
    private httpClient: HttpClient,
  ) { }

  // [GET] tournament groups
  public getTournamentGroups(tournamentId: string): Observable<{ [index: string]: any; }> {
    return this.httpClient.get<HttpResponse<object>>
      (environment.api_server + _.replace(environment.api_endpoints.tournamentGroups, ':tournament', tournamentId), {
        params: {}, observe: 'response'
      });
  }

  // [POST] create tournament groups
  public createTournamentGroups(tournamentId: string, type: string = 'chess'): Observable<{ [index: string]: any; }> {
    const apiEndpoint = _.reduce(
      [[':type', type], [':tournament', tournamentId]],
      (res, [key, replacement]) => _.replace(res, key!, replacement!),
      environment.api_endpoints.tournamentGroupsCreate
    );
    return this.httpClient.post<HttpResponse<object>>
      (environment.api_server + apiEndpoint, {
        params: {}, observe: 'response'
      });
  }
}
